import * as React from "react";
import { Divider, Grid, List } from "@mui/material";
import ListItems from "./ListItem";
import "./assets/layout.scss";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import { useSelector } from "react-redux";
import { getCountryBaseNameFromUrl } from "@/utils/Common";
import { useNavigate } from "react-router";
import { config, isProject } from "../../config";
const drawerWidth = 280;
const openedMixin = (theme) => ({
    width: drawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
});
const closedMixin = (theme) => ({
    overflowX: "hidden",
    width: `calc(${theme.spacing(6.5)} + 1px)`,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
});
const DrawerHeader = styled("div")(({ theme }) => (Object.assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar)));
const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => (Object.assign({ zIndex: theme.zIndex.drawer + 1, transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }) }, (open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
}))));
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => (Object.assign(Object.assign({ width: drawerWidth, flexShrink: 0, whiteSpace: "nowrap", boxSizing: "border-box" }, (open && Object.assign(Object.assign({}, openedMixin(theme)), { "& .MuiDrawer-paper": openedMixin(theme) }))), (!open && Object.assign(Object.assign({}, closedMixin(theme)), { "& .MuiDrawer-paper": closedMixin(theme) })))));
const NavBar = (props) => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(props.isDrawerOpen);
    const navigationState = useSelector((state) => state.navigationReducer);
    const navigate = useNavigate();
    // Get theme colors from config
    const primaryColor = config.theme.primaryColor;
    // Get logo based on project
    const getLogo = () => {
        if (isProject("zippyy")) {
            return {
                full: require("../../assets/Onboarding/Zippyy-Logo-White.svg").default,
                icon: require("../../assets/Onboarding/Zippyy-icon.png").default,
            };
        }
        else if (isProject("bigship")) {
            return {
                full: require("../../assets/Onboarding/Bigship_logo.svg").default,
                icon: require("../../assets/Onboarding/Bigship_Icon.png").default,
            };
        }
        else if (isProject("shipnexa")) {
            return {
                full: require("../../assets/Onboarding/Shipnexa_logo.svg").default,
                icon: require("../../assets/Onboarding/shipnexa_Icon.png").default,
            };
        }
        else if (isProject("stcourier")) {
            return {
                full: require("../../assets/Onboarding/Stcourier_logo.svg").default,
                icon: require("../../assets/Onboarding/Stcourier_Icon.svg").default,
            };
        }
        return {
            full: require("../../assets/Onboarding/Zippyy-Logo-White.svg").default,
            icon: require("../../assets/Onboarding/Zippyy-icon.png").default,
        };
    };
    const logos = getLogo();
    const baseNavItems = [
        {
            rootItem: {
                name: "Tenant manager",
                icon: "notification",
                path: "/tenantManager",
                active: false,
            },
        },
        {
            rootItem: {
                name: "Admin panel",
                icon: "AdminPanel",
                active: false,
                path: "",
            },
            subItems: [
                {
                    name: "Invoicing",
                    icon: "invoicing",
                    path: "/invoice",
                    active: false,
                },
                {
                    name: "Final charges",
                    icon: "finalCharges",
                    path: "/charges",
                    active: false,
                },
                {
                    name: "Finance",
                    icon: "finance",
                    path: "/finance",
                    active: false,
                },
                {
                    name: "Remittance approvals",
                    icon: "remittance-approvals",
                    path: "/remittance-approvals",
                    active: false,
                },
            ],
        },
        {
            rootItem: {
                name: "Rate management",
                icon: "rateManagement",
                active: false,
                path: "",
            },
            subItems: [
                {
                    name: "Carrier rate controls",
                    icon: "carrier-rate-controls",
                    path: "/rate-management/carrier-rate-controls",
                    active: false,
                },
                {
                    name: "Default Carrier",
                    icon: "default-carrier-config",
                    path: "/rate-management/default-carrier-config",
                    active: false,
                },
                {
                    name: "Rate configuration",
                    icon: "rate-configuration",
                    path: "/rate-management/configuration",
                    active: false,
                },
                {
                    name: "Vas controls",
                    icon: "vas-controls",
                    path: "/vas-control",
                    active: false,
                },
                {
                    name: "Audit logs",
                    icon: "audit-logs",
                    path: "/rate-management/audit-logs",
                    active: false,
                },
            ],
        },
        {
            rootItem: {
                name: "Rate card",
                icon: "ratecard",
                path: "/ratecard",
                active: false,
            },
        },
        {
            rootItem: {
                name: "Bulk activity",
                icon: "bulkaction",
                path: "/bulkactivity",
                active: false,
            },
        },
        {
            rootItem: {
                name: "Shipment disputes",
                icon: "shipmentDispute",
                path: "",
                active: false,
            },
            subItems: [
                {
                    name: "Weight disputes",
                    icon: "weightDispute",
                    path: "/weightdispute/bulk",
                    active: false,
                },
            ],
        },
    ];
    const zippyyOnlyItems = [
        {
            rootItem: {
                name: "MIS B2B",
                icon: "misB2B",
                path: "/mis",
                active: false,
            },
        },
    ];
    const getNavItems = () => {
        if (isProject("zippyy")) {
            return [...baseNavItems, ...zippyyOnlyItems];
        }
        return baseNavItems;
    };
    const [navListItems, setNavListItems] = React.useState(getNavItems());
    const setActiveByNavigationURL = (url) => {
        const presentLocation = getCountryBaseNameFromUrl();
        url = url.replace(new RegExp(`^${presentLocation}\\b`), "");
        const navListItemsTemp = [...navListItems];
        navListItemsTemp.forEach((item) => {
            item.rootItem.active =
                (item.subItems && item.subItems.filter((x) => x.path.startsWith(url)).length !== 0) ||
                    item.rootItem.path.startsWith(url);
            if (item.subItems) {
                item.subItems = item.subItems.map((subItem) => (Object.assign(Object.assign({}, subItem), { active: subItem.path === url })));
            }
        });
        setNavListItems(navListItemsTemp);
    };
    React.useEffect(() => {
        setActiveByNavigationURL(window.location.pathname);
    }, []);
    React.useEffect(() => {
        if (navigationState.data)
            setActiveByNavigationURL(window.location.pathname);
    }, [navigationState]);
    React.useEffect(() => {
        setOpen(props.isDrawerOpen);
    }, [props.isDrawerOpen]);
    const setActive = (value, item) => {
        const navListItemsTemp = [...navListItems];
        navListItemsTemp.forEach((navItem) => {
            navItem.rootItem.active = false;
            if (navItem.subItems) {
                navItem.subItems = navItem.subItems.map((subItem) => (Object.assign(Object.assign({}, subItem), { active: false })));
            }
        });
        navListItemsTemp.forEach((root) => {
            var _a;
            if (root.rootItem.name === value.rootItem.name) {
                root.rootItem.active = true;
                if (((_a = root.subItems) === null || _a === void 0 ? void 0 : _a.length) && item) {
                    root.subItems.forEach((element) => {
                        if (element.name === item.name) {
                            element.active = true;
                        }
                    });
                }
            }
        });
        setNavListItems(navListItemsTemp);
    };
    return (React.createElement(Box, { sx: { display: "flex" }, onMouseEnter: () => props.handleHover(true), onMouseLeave: () => props.handleHover(false) },
        React.createElement(Drawer, { variant: "permanent", open: open },
            React.createElement(DrawerHeader, { style: { background: primaryColor }, onClick: () => {
                    navigate("/home");
                    window.dispatchEvent(new Event("storageAccessTokenChange"));
                } },
                React.createElement(Grid, { container: true, alignItems: "center", justifyContent: "flex-start", direction: "row", style: { height: "60px" } },
                    open && (React.createElement(Grid, { item: true, xs: true },
                        React.createElement("img", { src: logos.full, alt: "Logo", style: { width: "57%" } }))),
                    !open && (React.createElement(Grid, { item: true, xs: true },
                        React.createElement("img", { src: logos.icon, alt: "Logo", style: { width: "57%", marginLeft: 5 } }))))),
            React.createElement(Divider, { flexItem: true, className: "nv_border_color" }),
            React.createElement(Box, { style: { height: "calc(100vh - 160px)", overflowY: "auto" } },
                React.createElement(List, { sx: { width: "100%", maxWidth: drawerWidth, bgcolor: "background.paper" }, component: "nav", "aria-labelledby": "nested-list-subheader" }, navListItems &&
                    navListItems.map((item, i) => {
                        return React.createElement(ListItems, { key: i, itemData: item, isDrawerOpen: open, setActive: setActive });
                    }))))));
};
export default NavBar;
